//@flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Spring } from 'react-spring/renderprops.cjs'
import iconCorrect from './correct.svg'
import iconIncorrect from './incorrect.svg'
import iconInfo from './info.svg'
import firebase from 'firebase/app'
import 'firebase/database'
import Lottie from 'react-lottie'
import './styles.scss'

let answerPercent = 0
let comparePercent = 0

const barDuration = 850
const iconWidth = 81 // this gets translated to a padding > see div.icon-wrapper below
const barWidth = browserCheck.isMobile ? '10%' : '17%'

const FeedbackIcon = (props) => {
  return(
    <div className="feedback-icon">
      {!props.isCorrect && (
        <img src={iconIncorrect} className='incorrect-icon' alt='incorrect' />
      )}
      {props.isCorrect && (
        <img src={iconCorrect} className='correct-icon' alt='correct' />
      )}
    </div>
  )
}


export class Battle extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      userAnswer: null,
      localAnswer: null,
      isCorrect: null,
      animationDone: false,
      leftHeightPercent: 0,
      rightHeightPercent: 0,
      totalVotes: 0,
      answerLeftPercent: null,
      answerRightPercent: null
    }

     // Init Firebase
     const config = {
      apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
      authDomain: 'stromfresser-battle.europe-west1.firebasedatabase.app',
      databaseURL: 'https://stromfresser-battle.europe-west1.firebasedatabase.app',
      storageBucket: 'ta-interaktiv.appspot.com'
    }
    if (!firebase.apps.length) {
      // console.log('firebase.apps', firebase.apps)
      firebase.initializeApp(config)
    }
  }

  evaluate(answer, answerValue, compareValue) {
    console.log('answer', answer)
    if(this.state.localAnswer !== null && this.state.userAnswer === null) {
      this.setState({userAnswer: this.state.localAnswer})
      if(answerValue > compareValue) {
        this.setState({isCorrect: true})
        answerPercent = 100
        comparePercent = 100/(answerValue/compareValue)
      } else {
        this.setState({isCorrect: false})
        comparePercent = 100
        answerPercent = 100/(compareValue/answerValue)
      }
      if(answer === 'left') {
        this.setState({leftHeightPercent: answerPercent, rightHeightPercent: comparePercent})
      } else {
        this.setState({leftHeightPercent: comparePercent, rightHeightPercent: answerPercent})
      }
  } else if(this.state.userAnswer === null) {
      this.setState({userAnswer: answer})
      if(answerValue > compareValue) {
        this.setState({isCorrect: true})
        answerPercent = 100
        comparePercent = 100/(answerValue/compareValue)
      } else {
        this.setState({isCorrect: false})
        comparePercent = 100
        answerPercent = 100/(compareValue/answerValue)
      }
      if(answer === 'left') {
        this.setState({leftHeightPercent: answerPercent, rightHeightPercent: comparePercent})
        this.addVote(this.props.questionID, 'l')
      } else {
        this.setState({leftHeightPercent: comparePercent, rightHeightPercent: answerPercent})
        this.addVote(this.props.questionID, 'r')
      }
      localStorage.setItem(this.props.questionID, JSON.stringify(answer))
       // track in google analytics
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `evaluate:` + this.props.questionID
      })
    }
  }

  showFeedback() {
    this.setState({animationDone: true})
  }

  /* increment in firebase */
  addVote(questionID, answer) {
    const newVote = firebase
      .database()
      .ref(questionID + '/' + answer)
    newVote.transaction(
      currentVotes => {
        return currentVotes + 1
      },
      (error, committed, snapshot) => {
        if (error) {
          // console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          // console.log('Transaction aborted')
        } else {
          /* transaction complete */
          this.getVotes()
        }
      }
    )
  }

  getVotes() {
    // console.log('get votes rom firebase for', this.state.tippID)
    /* firebase request */
    firebase
      .database()
      .ref(this.props.questionID)
      .once('value')
      .then(snapshot => {
        const leftVotes = snapshot.child('l').val()
        const rightVotes = snapshot.child('r').val()
        const answerLeftPercent = leftVotes/(leftVotes+rightVotes) * 100
        const answerRightPercent = rightVotes/(leftVotes+rightVotes) * 100
        this.setState({
          totalVotes: leftVotes+rightVotes,
          answerLeftPercent: Math.round(answerLeftPercent) || 0,
          answerRightPercent: Math.round(answerRightPercent) || 0
        })
      })
    //this.getLocalVotes()
  }

  getLocalVotes() {
    const localVote = JSON.parse(localStorage.getItem(this.props.questionID))
    // console.log('localVote', localVote)
    if (localVote !== null && localVote !== undefined) {
      this.setState({
        localAnswer: localVote
      }, function() {
        if(this.state.localAnswer === 'left') {
          this.evaluate(this.state.localAnswer, this.props.valueLeft, this.props.valueRight)
        } else {
          this.evaluate(this.state.localAnswer, this.props.valueRight, this.props.valueLeft)
        }
      }.bind(this))
    }
  }


  // helpers
  numberWithApostroph(x) {
      let num = x.toString()
      if(num.length > 4) {
        num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
      }
      return num;
  }
  numberWithComma(x) {
    return x.toString().replace('.', ',')
  }
  
  componentDidMount() {
    this.getVotes()
    this.getLocalVotes()
  }

  render() {

    const leftOptions = {
      animationData: this.props.iconLeft,
      loop: true,
      autoplay: true,
    }

    const rightOptions = {
      animationData: this.props.iconRight,
      loop: true,
      autoplay: true,
    }

    return <div className='battle'>
      <h3>{this.props.title}</h3>
      <div className={!this.state.animationDone ? 'row' : this.state.isCorrect === true ? 'row correct' : 'row incorrect'}>

        <div className={this.state.userAnswer === 'left' ? 'option left selected' : this.state.userAnswer === 'right' ? 'option left disabled' : 'option left'} onClick={() => this.evaluate('left', this.props.valueLeft, this.props.valueRight)}>
          <div className="icon-wrapper" style={{width: this.state.userAnswer === null ? '100%' : iconWidth+'%', paddingLeft: this.state.userAnswer === null ? (100-iconWidth)/2+'%' : 0, paddingRight: this.state.userAnswer === null ? (100-iconWidth)/2+'%' : 0}}>
              <div className="animation-wrapper">
                <Lottie options={leftOptions}/>
              </div>
              {/* <img src={this.props.iconLeft} alt="icon" /> */}
            <div className='description' dangerouslySetInnerHTML={ { __html: this.props.optionLeft}} />
          </div>
            <div className="bar-wrapper left" style={{width: this.state.userAnswer !== null ? barWidth : 0}}>
              <div className="spacer">
                <Spring
                  from={{h: 0, kwh: 0}}
                  to={{
                    h: this.state.userAnswer !== null
                      ? this.state.leftHeightPercent
                      : 0,
                    kwh:  this.props.valueLeft
                  }}
                  onRest={() =>
                    this.showFeedback()
                  }
                  config={{
                    duration: barDuration
                  }}
                >
                  {props => (
                      <>
                       {this.state.userAnswer !== null && (
                          <div className="usage" style={{ bottom: Math.round(props.h) + '%' }}>{this.numberWithComma(Math.round(props.kwh * 100) / 100)} kWh</div>
                       )}
                        <div className="bar left" style={{ height: Math.round(props.h) + '%' }} />
                      </>
                      
                  )}
                </Spring>
              </div>
            </div>
            {this.state.animationDone === true && this.state.userAnswer === 'left' && (
              <FeedbackIcon isCorrect={this.state.isCorrect} />
            )}
        </div>

        <div className="divider" />

        <div className={this.state.userAnswer === 'right' ? 'option right selected' : this.state.userAnswer === 'left' ? 'option right disabled' : 'option right'} onClick={() => this.evaluate('right', this.props.valueRight, this.props.valueLeft)}>
            <div className="bar-wrapper right" style={{width: this.state.userAnswer !== null ? barWidth : 0}}>
              <div className="spacer">
              <Spring
                  from={{h: 0, kwh: 0}}
                  to={{
                    h: this.state.userAnswer !== null
                      ? this.state.rightHeightPercent
                      : 0,
                    kwh:  this.props.valueRight
                  }}
                  onRest={() =>
                    this.showFeedback()
                  }
                  config={{
                    duration: barDuration
                  }}
                >
                  {props => (
                      <>
                        {this.state.userAnswer !== null && (
                          <div className="usage" style={{ bottom: Math.round(props.h) + '%' }}>{this.numberWithComma(Math.round(props.kwh * 100) / 100)} kWh</div>
                        )}
                        <div className="bar right" style={{ height: Math.round(props.h) + '%' }} />
                      </>
                      
                  )}
                </Spring>
              </div>
            </div>
          <div className="icon-wrapper" style={{width: this.state.userAnswer === null ? '100%' : iconWidth+'%', paddingLeft: this.state.userAnswer === null ? (100-iconWidth)/2+'%' : 0, paddingRight: this.state.userAnswer === null ? (100-iconWidth)/2+'%' : 0}}>
            <div className="animation-wrapper">
              <Lottie options={rightOptions}/>
            </div>
            {/*
            <img src={this.props.iconRight} alt="icon" />
            */}
            <div className='description' dangerouslySetInnerHTML={ { __html: this.props.optionRight}} />
          </div>
          {this.state.animationDone === true && this.state.userAnswer === 'right' && (
            <FeedbackIcon isCorrect={this.state.isCorrect} />
          )}
        </div>

        {this.state.userAnswer !== null && (
          <div className="feedback">
            {this.state.isCorrect === false && (
              <>
                <i className='icon false' />
                <div className="text">Das war leider <b>nicht korrekt</b>. {this.props.solution} <b>{this.state.answerLeftPercent !== null && (this.state.userAnswer === 'left' ? this.state.answerLeftPercent : this.state.answerRightPercent)}{this.state.answerLeftPercent === null && (<div className="loader" />)}%</b> der {this.state.totalVotes > 0 && (this.numberWithApostroph(this.state.totalVotes))}{this.state.totalVotes === 0 && (<div className="loader" />)} Leserinnen und Leser haben das wie Sie falsch eingeschätzt.</div>
              </>
            )}
            {this.state.isCorrect === true && (
              <>
                <i className='icon false' />
                <div className="text">Das war <b>korrekt</b>! {this.props.solution} <b>{this.state.answerRightPercent !== null && (this.state.userAnswer === 'left' ? this.state.answerLeftPercent : this.state.answerRightPercent)}{this.state.answerRightPercent === null && (<div className="loader" />)}%</b> der {this.state.totalVotes > 0 && (this.numberWithApostroph(this.state.totalVotes))}{this.state.totalVotes === 0 && (<div className="loader" />)} Leserinnen und Leser haben das wie Sie richtig eingeschätzt.</div>
              </>
            )}
          </div>
        )}

      {this.state.userAnswer === null && (
          <div className="info">
            <div>
              <img src={iconInfo} className='correct-icon' alt='correct' />
              <div className="detail" dangerouslySetInnerHTML={ { __html: this.props.detailLeft}} />
            </div>
            <div>
              <img src={iconInfo} className='correct-icon' alt='correct' />
              <div className="detail" dangerouslySetInnerHTML={ { __html: this.props.detailRight}} />
            </div>
          </div>
        )}
      </div>

    </div>
  }
}
